var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAreaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5935 6.98521C14.7909 6.82945 15.0601 6.80015 15.2864 6.90977C15.4842 7.00576 15.619 7.19333 15.6497 7.40709L15.6562 7.50011V15.0001C15.6562 15.3625 15.3624 15.6564 15 15.6564H3C2.63756 15.6564 2.34375 15.3625 2.34375 15.0001V11.0531C2.3438 10.8707 2.41965 10.6973 2.55103 10.5741L2.61035 10.5243L6.36035 7.76158C6.56286 7.61241 6.83023 7.59334 7.04883 7.70518L7.13965 7.76158L10.4868 10.2269L14.5935 6.98521Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6616 3.93761C14.9465 3.76584 15.3212 3.83436 15.5251 4.10606C15.729 4.37786 15.6898 4.75659 15.4453 4.98204L15.394 5.02525L10.894 8.40025C10.6642 8.57263 10.3484 8.57505 10.1155 8.40684L6.75 5.97667L3.38452 8.40684L3.32812 8.44347C3.04025 8.61012 2.66733 8.53491 2.46826 8.25963C2.2694 7.98415 2.31486 7.60607 2.56348 7.38512L2.61548 7.34337L6.36548 4.63487C6.5661 4.49003 6.82843 4.4721 7.04443 4.58067L7.13452 4.63487L10.4927 7.05992L14.606 3.97496L14.6616 3.93761Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreaIcon);
export default __webpack_public_path__ + "static/media/areaIcon.17dbda703e6c4e6798fb83380c0ce200.svg";
export { ForwardRef as ReactComponent };